export default __webpack_public_path__ + "static/media/mximg3.bfe539c2.webp";